export default __webpack_public_path__ + "static/media/Back.15bbb2c4.svg";